import AxiosService from '@/services/AxiosServices'

export default {
  /**
   * AD-68: demande de réinitialisation. Réponse uniforme (anti-énumération) ; l'envoi de
   * l'e-mail se fait côté serveur si le compte existe.
   * @param email
   * @returns {*}
   */
  checkUserByEmail(email) {
    return AxiosService.callApi().post('/reset-password/check-user-mail', email)
  },
  /**
   * AD-68: validation du lien à l'ouverture, sans changer le mot de passe.
   * @param token
   * @param id
   * @returns {*}
   */
  validateToken(token, id) {
    return AxiosService.callApi().get('/reset-password/validate/' + token + '/' + id)
  },
  /**
   * Update password
   *
   * @param token
   * @param id
   * @param password
   * @returns {*}
   */
  changePasswordRequest(token, id, password) {
    return AxiosService.callApi().post('/reset-password/change_password/' + token + '/' + id, password)
  }
}
